import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    opacity: '0.35',
    color: '#323436',
    fontSize: theme.size.sm,

    [theme.breakpoints.down(611)]: {
      marginBottom: '-2rem',
      visibility: 'hidden'
    }
  },

  uploadIcon: {
    marginRight: '4px',
    cursor: 'pointer'
  },

  loading: {
    marginTop: '1rem'
  },

  files: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',

    [theme.breakpoints.down(611)]: {
      justifyContent: 'center'
    }
  },

  file: {
    marginTop: '1rem'
  }
}))

export default useStyles
